/**
 * Extrae el slug de la sección del sitio a partir de una URL de callback.
 * El primer segmento del pathname de la URL identifica la sección
 * (ej: "notas", "juegos", "club"). Si el path es raíz o vacío, retorna "home".
 * Si la URL es inválida o no se puede determinar, retorna "desconocido".
 * @param {String} url URL de callback del usuario antes de iniciar sesión
 * @returns {String}
 */
const getSeccionFromUrl = (url) => {
    try {
        if (!url) return 'desconocido';

        const parsedUrl = new URL(url);
        const segments = parsedUrl.pathname
            .split('/')
            .filter((segment) => segment !== '');

        if (segments.length === 0) return 'home';

        return segments[0];
    } catch {
        return 'desconocido';
    }
};

export { getSeccionFromUrl };
